import { useNavigate } from "react-router-dom"
import { RegistrationHeader } from "../RegistrationHeader/RegistrationHeader";
import SignUpPopup from "./SignUpPopup/SignUpPopup";
import React, { useState } from "react";
import { t } from "i18next";
import { GenderDDL } from "../../Components/CommonDDL/GenderDDL";
import { useDispatch } from "react-redux";
import { CitizenRegistrationPostAPI } from "../../Helper/Redux/Registration/RegistrationSlice";
import { RegExEmail, RegExMobile, RegExNumbersOnly, RegExOnlyText, RegExPassword } from "../../Helper/RegEx";
import moment from "moment";
import '../../theme/amchi-theme.css'


export const WithRegistration = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [SignUpShowPopup, setSignUpShowPopup] = useState(false)

    const [CitizenField, setCitizenField] = useState({
        CitizenName: '',
        DateOfBirth: '',
        EmailAddress: '',
        MobileNo: '',
        Gender: '',
        Address: '',
        UserName: '',
        Password: '',
        ConfirmPassword: '',
    })

    const [GenderDDLID, setGenderDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: 'Select...'
    })
    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: 'English'
    })

    const showPass = () => {
        var x = document.getElementById("pass");
        var y = document.getElementById("pass-eye");
        if (x.type === "password") {
            x.type = "text";
            y.className = "fa fa-eye-slash";
        } else {
            x.type = "password";
            y.className = "fa fa-eye";
        }
    }

    // same toggle, for the password field itself
    const showNewPass = () => {
        var x = document.getElementById("newpass");
        var y = document.getElementById("newpass-eye");
        if (x.type === "password") {
            x.type = "text";
            y.className = "fa fa-eye-slash";
        } else {
            x.type = "password";
            y.className = "fa fa-eye";
        }
    }

    const onChange = (e) => {
        const { name, value } = e.target
        setCitizenField(item => ({
            ...item, [name]: value
        }))
    }

    const [IsValidText, setIsValidText] = useState(false)
    const handleCheckText = (e) => {
        onChange(e)
        const IsValid = RegExOnlyText(e.target.value)
        setIsValidText(IsValid)
        return IsValid
    }

    const [IsValidEmail, setIsValidEmail] = useState(false)
    const handleCheckEmail = (e) => {
        onChange(e)
        const IsValid = RegExEmail(e.target.value)
        setIsValidEmail(IsValid)
        return IsValid
    }

    const [IsValidNumber, setIsValidNumber] = useState(false)
    const handleCheckNumberOnly = (e) => {
        onChange(e)
        const IsValid = RegExNumbersOnly(e.target.value)
        setIsValidNumber(IsValid)
        return IsValid
    }

    const [IsValidPassword, setIsValidPassword] = useState(false)
    const handleCheckPassword = (e) => {
        onChange(e)
        const IsValid = RegExPassword(e.target.value)
        setIsValidPassword(IsValid)
        return IsValid
    }

    const handleIsPost = () => {
        setSignUpShowPopup(!SignUpShowPopup)
    }

    const handleRegister = () => {
        const data = {
            CitizenField: CitizenField,
            M_IndicatorGenderID: GenderDDLID.ID,
            M_UserID: '0',
            handleIsPost: handleIsPost,
        }
        dispatch(CitizenRegistrationPostAPI({ data }))
    }

    return (
        <>
            <div className="am-page" onLoad={() => window.scrollTo(0, 0)}>

                <div className="am-decor" aria-hidden="true">
                    <span className="am-blob am-blob-1"></span>
                    <span className="am-blob am-blob-2"></span>
                    <span className="am-blob am-blob-3"></span>
                </div>

                <RegistrationHeader
                    Language={Language}
                    setLanguage={setLanguage}
                />

                <main className="am-shell am-form-wrap">

                    <div className="am-page-head am-rise">
                        <div>
                            <span className="am-pill"><i className="fa-solid fa-user-plus"></i> नागरिक नोंदणी</span>
                            <h1>{t('CitizenRegistration.CitizenRegistration')}</h1>
                            <p>
                                खालील माहिती भरून नोंदणी पूर्ण करा. नोंदणीनंतर तुम्हाला तक्रार दाखल करता येईल
                                व तक्रारीची सद्यस्थिती पाहता येईल.
                            </p>
                        </div>
                    </div>

                    <section className="am-card am-form-card am-rise am-rise-2">
                        <div className="am-form-head">
                            <span className="am-form-head-ico"><i className="fa-solid fa-id-card"></i></span>
                            <div>
                                <h2>{t('CitizenRegistration.CitizenRegistration')}</h2>
                                <p><span className="am-req">*</span> चिन्ह असलेली माहिती अनिवार्य आहे</p>
                            </div>
                        </div>

                        <div className="am-form-body">
                            <div className="am-form-grid">

                                <div className="am-form-item">
                                    <label className="am-label">
                                        {t('CitizenRegistration.CitizenName')} <span className="am-req">*</span>
                                    </label>
                                    <div className="am-field">
                                        <i className="fa-solid fa-user"></i>
                                        <input
                                            type="text"
                                            placeholder={t('CitizenRegistration.CitizenName')}
                                            name='CitizenName'
                                            value={CitizenField.CitizenName}
                                            onChange={handleCheckText}
                                        />
                                    </div>
                                    {
                                        IsValidText && <span className="am-hint">Please enter Alphabet characters only</span>
                                    }
                                </div>

                                <div className="am-form-item">
                                    <label className="am-label">
                                        {t('CitizenRegistration.DateOfBirth')} <span className="am-req">*</span>
                                    </label>
                                    <div className="am-field">
                                        <input
                                            type="date"
                                            className="am-input--bare"
                                            placeholder={t('CitizenRegistration.DateOfBirth')}
                                            name='DateOfBirth'
                                            max={moment().format('YYYY-MM-DD')}
                                            value={CitizenField.DateOfBirth}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>

                                <div className="am-form-item">
                                    <label className="am-label">
                                        {t('CitizenRegistration.EmailAddress')} <span className="am-req">*</span>
                                    </label>
                                    <div className="am-field">
                                        <i className="fa-solid fa-envelope"></i>
                                        <input
                                            type="text"
                                            placeholder={t('CitizenRegistration.EmailAddress')}
                                            name='EmailAddress'
                                            value={CitizenField.EmailAddress}
                                            onChange={handleCheckEmail}
                                        />
                                    </div>
                                    {
                                        IsValidEmail && <span className="am-hint">Please enter valid Email Address</span>
                                    }
                                </div>

                                <div className="am-form-item">
                                    <label className="am-label">
                                        {t('CitizenRegistration.MobileNo')} <span className="am-req">*</span>
                                    </label>
                                    <div className="am-field">
                                        <i className="fa-solid fa-mobile-screen"></i>
                                        <input
                                            type="text"
                                            placeholder={t('CitizenRegistration.MobileNo')}
                                            name='MobileNo'
                                            value={CitizenField.MobileNo}
                                            onChange={handleCheckNumberOnly}
                                            maxLength={10}
                                        />
                                    </div>
                                    {
                                        IsValidNumber && <span className="am-hint">Please enter Numbers only</span>
                                    }
                                </div>

                                <div className="am-form-item">
                                    <label className="am-label">
                                        {t('CitizenRegistration.Gender')} <span className="am-req">*</span>
                                    </label>
                                    <div className="am-field am-field--select">
                                        <i className="fa-solid fa-venus"></i>
                                        <GenderDDL
                                            GenderDDLID={GenderDDLID}
                                            setGenderDDLID={setGenderDDLID}
                                            Language={Language}
                                            GroupID='2'
                                        />
                                    </div>
                                </div>

                                <div className="am-form-item">
                                    <label className="am-label">
                                        {t('CitizenRegistration.Address')} <span className="am-req">*</span>
                                    </label>
                                    <div className="am-field am-field--ta">
                                        <i className="fa-solid fa-location-dot"></i>
                                        <textarea
                                            placeholder={t('CitizenRegistration.Address')}
                                            name='Address'
                                            value={CitizenField.Address}
                                            onChange={onChange}
                                        ></textarea>
                                    </div>
                                </div>

                                <div className="am-form-item">
                                    <label className="am-label">
                                        {t('CitizenRegistration.UserName')} <span className="am-req">*</span>
                                    </label>
                                    <div className="am-field">
                                        <i className="fa-solid fa-circle-user"></i>
                                        <input
                                            type="text"
                                            placeholder={t('CitizenRegistration.UserName')}
                                            name='UserName'
                                            value={CitizenField.UserName}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>

                                <div className="am-form-item">
                                    <label className="am-label">
                                        {t('CitizenRegistration.Password')} <span className="am-req">*</span>
                                    </label>
                                    <div className="am-field">
                                        <i className="fa-solid fa-lock"></i>
                                        <input
                                            id='newpass'
                                            type="password"
                                            placeholder={t('CitizenRegistration.Password')}
                                            name='Password'
                                            value={CitizenField.Password}
                                            onChange={handleCheckPassword}
                                        />
                                        <button
                                            type="button"
                                            className="am-eye"
                                            aria-label="पासवर्ड दाखवा / लपवा"
                                            onClick={showNewPass}
                                        >
                                            <i id="newpass-eye" className="fa fa-eye"></i>
                                        </button>
                                    </div>
                                    {
                                        IsValidPassword &&
                                        <span className="am-hint">
                                            Please enter Minimum six characters, at least one uppercase letter,
                                            one lowercase letter, one number and one special character.
                                        </span>
                                    }
                                </div>

                                <div className="am-form-item">
                                    <label className="am-label">
                                        {t('CitizenRegistration.ConfirmPassword')} <span className="am-req">*</span>
                                    </label>
                                    <div className="am-field">
                                        <i className="fa-solid fa-lock-open"></i>
                                        <input
                                            id='pass'
                                            type="password"
                                            placeholder={t('CitizenRegistration.ConfirmPassword')}
                                            name='ConfirmPassword'
                                            value={CitizenField.ConfirmPassword}
                                            onChange={onChange}
                                        />
                                        <button
                                            type="button"
                                            className="am-eye"
                                            aria-label="पासवर्ड दाखवा / लपवा"
                                            onClick={showPass}
                                        >
                                            <i id="pass-eye" className="fa fa-eye"></i>
                                        </button>
                                    </div>
                                    {
                                        (CitizenField.Password != CitizenField.ConfirmPassword) && CitizenField.ConfirmPassword != '' &&
                                        <span className="am-hint">Password Mismatch</span>
                                    }
                                </div>

                            </div>
                        </div>
                    </section>

                    <div className="am-form-actions am-rise am-rise-3">
                        <button type="button"
                            className="am-btn am-btn--primary"
                            disabled={CitizenField.CitizenName == '' || CitizenField.DateOfBirth == '' || CitizenField.EmailAddress == '' || (CitizenField.MobileNo.length == 10) == '' ||
                                GenderDDLID.ID == '0' || CitizenField.Address == '' || CitizenField.UserName == '' || CitizenField.Password == '' || CitizenField.ConfirmPassword == '' || (CitizenField.Password != CitizenField.ConfirmPassword)}
                            onClick={handleRegister}
                        >
                            <i className="fa-solid fa-check"></i> {t('CitizenRegistration.Register')}
                        </button>

                        <button type="button"
                            className="am-btn am-btn--ghost"
                            onClick={() => navigate('/')}
                        >
                            <i className="fa-solid fa-xmark"></i> {t('CitizenRegistration.Cancel')}
                        </button>
                    </div>

                    <footer className="am-footer">
                        <span>© {moment().format('YYYY')} सार्वजनिक आरोग्य विभाग, महाराष्ट्र शासन · सर्व हक्क राखीव</span>
                        <span>
                            <i className="fa-solid fa-phone-volume"></i> टोल फ्री : <a href="tel:18002334475">1800 233 4475</a>
                        </span>
                    </footer>
                </main>
            </div>

            {
                SignUpShowPopup ?
                    <SignUpPopup
                        setSignUpShowPopup={setSignUpShowPopup}
                        CitizenField={CitizenField}
                    />
                    : ''
            }
        </>
    )
}
